module.exports = __webpack_public_path__ + "img/guozai_10.df0a5c7b.jpg";